export default __webpack_public_path__ + "static/media/theme-blue.0b4736f1.svg";